import * as R from 'ramda';

import WorkOrderStatusPill from '@atom/components/common/workOrderDetail/workOrderStatusPill/WorkOrderStatusPill';
import { useNavigation } from '@atom/hooks/useNavigation';
import { WorkCollectionItem } from '@atom/types/work';
import timeUtilities from '@atom/utilities/timeUtilities';
import userUtilities from '@atom/utilities/userUtilities';

import classes from './mapDrawerContent.module.css';

interface Props {
  work: WorkCollectionItem;
}

const WorkRow = ({ work }: Props) => {
  const assigneeCount = userUtilities.rollUpTaskUsers(work.tasks).length;
  const taskCount = R.isEmpty(work.tasks) ? 0 : work.tasks.length;
  const [, { navigate }] = useNavigation();
  return (
    <div
      className={classes.workRowContainer}
      onClick={() => navigate(`/workOrders/${work.id}`)}
    >
      <div className={classes.workRowContent}>
        <div className={classes.workRowName}>{work.name}</div>
        <WorkOrderStatusPill
          statusId={work.statusId}
          className="dashboard-map-list"
        />
        <div className={classes.workRowDetailsContainer}>
          <div className={classes.workDetailContent}>
            Due Date: {timeUtilities.setDisplayDate(work.dueDate)}
          </div>
          <div className={classes.workDetailContent}>Team: {assigneeCount}</div>
          <div className={classes.workDetailContent}>Tasks: {taskCount}</div>
        </div>
      </div>
    </div>
  );
};

export default WorkRow;
